export default "__VITE_ASSET__2841fd1e__"